const PulseAnimation = () => {
  const styles = `
       .midpulse {
            animation: midpulse 1s infinite;
        }
        .bigpulse {
            animation: bigpulse 1s infinite;
        }
        .smallpulse {
            animation: smallpulse 1s infinite;
        }

        @keyframes midpulse {
            from {
            r: 15%;
          }
          to {
            r: 30%;
          }
        }
        
        @keyframes bigpulse {
            from {
              r: 30%;
            }
            to {
              r: 45%;
            }
        }
        
        @keyframes smallpulse {
            from {
              r: 0%;
            }
            to {
              r: 15%;
            }
        }
        

        @keyframes fade {
            0%, 100% {
                opacity: 0.3;
            }
            50% {
                opacity: 1;
            }
        }
    `;

  return (
    <>
      <style jsx>{styles}</style>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle className="bigpulse" cx="12" cy="12" r="12" fill="#DC6803" opacity="0.1" />
        <circle className="midpulse" cx="12" cy="12" r="7" fill="#DC6803" opacity="0.3" />
        <circle className="smallpulse" cx="12" cy="12" r="3" fill="#DC6803" />
      </svg>
    </>
  );
};

export default PulseAnimation;
